import { render, staticRenderFns } from "./_SpecialTime.vue?vue&type=template&id=480f3340&scoped=true"
import script from "./_SpecialTime.vue?vue&type=script&lang=ts"
export * from "./_SpecialTime.vue?vue&type=script&lang=ts"
import style0 from "./_SpecialTime.vue?vue&type=style&index=0&id=480f3340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f3340",
  null
  
)

export default component.exports